export interface MeOverview {
    client: NewMeClient;
    account: NewMeAccount;
    officialPlan: MeOfficialPlan | null;
    addons: MeOfficialPlan[];
    limites: LimitUsage[];
}

export interface LimitUsage {
    feature: string;
    limite_mensal: number | null;
    consumo_atual: number;
    disponivel: number | null;
    porcentagem_uso: number;
    tipo_limite: string;
    tipo_reset: string;
    ilimitado?: boolean;
    outros_limites?: {
        totalIntegracaoAutomatica?: number | null;
        totalCheckoutAutomatico?: number | null;
        totalCampanhasIpBloqueados?: number | null;
    };
}

export interface ClientLocalFields {
    rede_ads_ativas?: number[] | null;
    vturb_api_key?: string | null;
    aceitou_termos_de_uso?: number | null;
    telegram_bot_token?: string | null;
    telegram_chat_id?: string | null;
}

export interface NewMeClient extends ClientLocalFields {
    id?: string;
    email?: string;
    name?: string;
    timezone?: string;
    formato_data?: string;
    formato_hora?: string;
    [key: string]: unknown;
}

export interface NewMeAccount {
    id?: string;
    externalClientId?: number | string;
    subscriberEmail?: string;
    [key: string]: unknown;
}

export interface MeOfficialPlan {
    subscriptionId?: string;
    productId?: string;
    productSlug?: string;
    productName?: string;
    productType?: 'plan' | 'addon' | string;
    productLevel?: number;
    productIsActive?: boolean;
    billingType?: string;
    startedAt?: string;
    expiresAt?: string | null;
    gracePeriodDays?: number;
    effectiveUntil?: string | null;
    inGrace?: boolean;
    isOfficialPlan?: boolean;
    comboProductId?: string | null;
    cycleStartAt?: string | null;
    cycleEndAt?: string | null;
    autoRenewCanceledAt?: string | null;
    [key: string]: unknown;
}

export interface MeApiResult {
    data: MeOverview;
    errors: unknown;
    message: string;
    success: boolean;
}
